import { materieelsoorten } from '@/utils/materieelsoorten';

export type LmmMaterieelCategory = 'i' | 's' | 'o';

/**
 * Categorizes a materieelsoort as intercity ('i'), sprinter ('s') or other ('o'), used to split
 * the LMM table into 'Intercities'/'Sprinters' sections.
 */
export const getLmmMaterieelCategory = (materieel: string): LmmMaterieelCategory => {
  const normalizedMaterieel = materieel.trim().toUpperCase();
  if (materieelsoorten.intercities.includes(normalizedMaterieel)) return 'i';
  if (materieelsoorten.sprinters.includes(normalizedMaterieel)) return 's';
  return 'o';
};

export const getLmmMaterieelCategoryFull = (materieel: string): 'sprinter' | 'intercity' | 'other' => {
  const abbreviation = getLmmMaterieelCategory(materieel);
  if (abbreviation === 's') return 'sprinter';
  if (abbreviation === 'i') return 'intercity';
  return 'other';
};
